if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super()
      this.interval = null
    }

    connectedCallback() {
      // compatible safari
      const endDate = this.dataset.endDate.replace('T', ' ').split('-').join('/')
      if (!endDate) return

      this.endTime = new Date(endDate).getTime()
      if (isNaN(this.endTime)) return

      // 使用 requestAnimationFrame 确保 DOM 渲染完成
      requestAnimationFrame(() => {
        this.daysEl = this.querySelector('[data-days] span')
        this.hoursEl = this.querySelector('[data-hours] span')
        this.minutesEl = this.querySelector('[data-minutes] span')
        this.secondsEl = this.querySelector('[data-seconds] span')

        if (!this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
          console.error('Countdown timer: Could not find all required elements')
          return
        }

        this.updateCountdown()
        this.interval = setInterval(() => this.updateCountdown(), 1000)
      })
    }

    disconnectedCallback() {
      if (this.interval) {
        clearInterval(this.interval)
      }
    }

    updateCountdown() {
      // 添加安全检查
      if (!this.daysEl || !this.hoursEl || !this.minutesEl || !this.secondsEl) {
        return
      }

      const now = new Date().getTime()
      const distance = this.endTime - now

      if (distance < 0) {
        // 倒计时结束，清除定时器并销毁整个组件
        if (this.interval) {
          clearInterval(this.interval)
        }
        if (this.dataset.hideAfterEnd) document.querySelector(this.dataset.hideAfterEnd)?.classList.add('hidden')
        this.remove()
        return
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)

      this.daysEl.textContent = String(days).padStart(2, '0')
      this.hoursEl.textContent = String(hours).padStart(2, '0')
      this.minutesEl.textContent = String(minutes).padStart(2, '0')
      this.secondsEl.textContent = String(seconds).padStart(2, '0')
    }
  }

  customElements.define('countdown-timer', CountdownTimer)
}
